"use strict";
export const MICROSITE_LINK = "https://www.topazdex.com/";
